import { resource } from "./resource";
import { invalidateOrgShifts } from "./globalData";

const api = resource("/shift");

// See department.js — the same rule, for the same reason.
const invalidating = (res) => {
  if (res?.success !== false) invalidateOrgShifts();
  return res;
};

export const createShift = async (input = {}) => invalidating(await api.post("", input));

export const getAllShift = async () => await api.get();

// Shift that applies to a given employee, resolved server-side (rotation-aware).
// `date` (ISO "YYYY-MM-DD") picks the rotation slot to resolve against.
export const getShiftForEmployee = async (employeeId, date) =>
  await api.get(`/employee/${employeeId}`, { date });

// The caller's own shift. `/employee/:id` would answer the same question, but
// only for a caller who already knows their own employee id; this needs nothing
// but the token, which is what the employee's own screens have.
export const getSelfShift = async () => await api.get("/self");

export const getShiftById = async (id) => await api.get(`/${id}`);

export const updateShift = async (id, input = {}) => invalidating(await api.put(`/${id}`, input));
